<div class="skill-architecture-selection">
    <div class="d-flex skill-architecture-selection-header">
        <div
            *ngIf="trainingType === 'RL'"
            id="observationTab"
            [class.selected]="selectedIndex === 0"
            class="dragBox"
            (click)="changeSelection(0)"
        >
            <span class="background"></span>
            {{ 'neuralNetwork.observations.tabName' | translate }}
        </div>
        <div
            *ngIf="trainingType === 'RL'"
            id="imageFeatureExtractor"
            [class.selected]="selectedIndex === 1"
            class="dragBox"
            (click)="changeSelection(1)"
        >
            <span class="background"></span>
            {{ 'neuralNetwork.imageFeatureExtractor.tabName' | translate }}
        </div>
        <div
            *ngIf="trainingType === 'RL'"
            id="codeEditor"
            [class.selected]="selectedIndex === 2"
            class="dragBox"
            (click)="changeSelection(2)"
        >
            <span class="background"></span>
            {{ 'neuralNetwork.codeEditor.tabName' | translate }}
        </div>
        <div
            *ngIf="trainingType === 'RL'"
            id="codeEditor"
            [class.selected]="selectedIndex === 3"
            class="dragBox"
            (click)="changeSelection(3)"
        >
            <span class="background"></span>
            {{ 'neuralNetwork.actionConfigurator.tabName' | translate }}
        </div>
    </div>
    <div class="skill-architecture-content">
        <app-observation-element-details
            #beforeStartComponent
            *ngIf="selectedIndex === 0"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
        ></app-observation-element-details>
        <app-image-feature-extractor
            *ngIf="selectedIndex === 1 && trainingType === 'RL'"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
        >
        </app-image-feature-extractor>
        <app-custom-randomization
            *ngIf="selectedIndex === 2"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
        ></app-custom-randomization>
        <app-action-configurator
            #beforeStartComponent
            *ngIf="selectedIndex === 3"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
        ></app-action-configurator>
    </div>
</div>
